import { createContext, useEffect, useMemo, useState, useContext } from 'react';
import { isEqual } from 'lodash';

import { Tag } from '@playq/octopus-common';

import { FCWithChildren } from '/common/models';

import { IProviderProps, IConfigValue } from '../types';

export const BeetleLookupContext = createContext<IConfigValue | null>(null);
export const useBeetleLookupContext = (): IConfigValue => {
  const context = useContext(BeetleLookupContext);
  if (!context) {
    throw new Error('useBeetleLookupContext must be used within a BeetleLookupProvider');
  }
  return context;
};

export const BeetleLookupProvider: FCWithChildren<IProviderProps> = ({ value, children }) => {
  const [currentTags, setCurrentTags] = useState<Tag[]>(value.entity.tags || []);
  const [error, setError] = useState<string>();

  useEffect(() => {
    const newTags = value.entity.tags || [];
    setCurrentTags((prevTags) => {
      if (isEqual(prevTags, newTags)) {
        return prevTags;
      }
      return newTags;
    });
  }, [value.entity.tags]);
  const contextValue = useMemo(
    () => ({
      ...value,
      currentTags,
      error,
      setCurrentTags,
      setError,
    }),
    [value, currentTags, error]
  );
  return <BeetleLookupContext.Provider value={contextValue}>{children}</BeetleLookupContext.Provider>;
};
